import React, { ReactNode } from "react";
import DashboardComponent from "../components/layout/dashboard";
import DrawerContainer from "../components/drawer-container/drawer-container";
import ModalContainer from "../components/modal-container/modal-container";
import ToastContainer from "../components/toast-container/toast-container";

interface DashboardLayoutProps {
  children: ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  return (
    <DashboardComponent>
      <div className="content">{children}</div>
      <DrawerContainer />
      <ModalContainer />
      <ToastContainer />
      <style>{`
      .content {
        margin-top: var(--bs-header-height);
        height: calc(100vh - var(--bs-header-height));
        background-color: #fff;
        padding: 45px 60px;;
        overflow: auto;
      }

      @media (max-width: 991px) {
        .content {
          padding: 45px;
      }}

      @media (max-width: 767px) {
        .content {
          padding: 30px;
          padding-bottom: 5px;
      }}


      `}</style>
    </DashboardComponent>
  );
};

export default DashboardLayout;
